/**
 * Smart Intake settings page for lite home navigation.
 * Displays the client signup invite link with copy functionality.
 */

import { Stack, Text, Title } from "@mantine/core";
import { SmartIntakeInviteLink } from "@components/SmartIntakeInviteLink";

interface SmartIntakeSettingsPageProps {
  onExit?: () => void;
}

const SmartIntakeSettingsPage: React.FC<SmartIntakeSettingsPageProps> = () => {
  return (
    <Stack gap="lg">
      <div>
        <Title order={3}>Smart Intake</Title>
        <Text size="sm" c="dimmed" mt="xs">
          Share your invite link with clients so they can create an account and
          upload their tax documents before their appointment.
        </Text>
      </div>
      <SmartIntakeInviteLink />
    </Stack>
  );
};

export default SmartIntakeSettingsPage;
